<template>
	<div class='publicHeader' :class="{'whitebg':isWhite}">
		<div class="container">
			<div class="icon_back" @click="handleIconBack">
				<img v-if="isWhite" src="https://images.zhibo.tv/2020/0122/icon_back_b@2x.png" alt="">
				<img v-else src="https://images.zhibo.tv/2020/0122/icon_back@2x.png" alt="">
			</div>
			<div class="pageTitle">
				{{pageTitle}}
			</div>
			<!-- <div class="icon_share" v-if="this.$route.name === 'vipBag'||this.$route.name === 'vipStar'" -->
			<div class="icon_share" v-if="this.$route.name === 'vipStar'"
				@click="gotoShare">
				<img src="https://images.zhibo.tv/2020/0126/icon_share@2x.png" alt="">
			</div>
			<div class="text_finish" v-if="this.$route.name === 'vipmiddpaysucc'" @click="finish">
				完成
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['pageTitle', 'isWhite', 'urlhandle'],
		components: {},
		data() {
			return {
				routeName: '',
				fromh5: '',
				token: '',
				// 分享需要
				shareTitle: '',
				shareDesc: '',
				shareUrl: '',
				shareImg: '',
				shareParams: '',
				// 二次分享需要
				appid: '',
				timestamp: '',
				nonceStr: '',
				ticket: '',
				url: '',
				// 是否是分享
				isShare: '',
				id: '',
				// 是否来自会员中心 
				isVipCenter: false,
				// 来自会员中心的页面
				vipCenterList: ['vipPay', 'vipiosPay', 'vipBag', 'vipStar', 'vipVideo', 'vipExchange', 'vipWelfare',
					'vipcoupon', 'vipRecord'
				],
				// 是否需要后退
				back: '',
				// 状态栏为深色的路由
				darkColorList: ['Home', 'vipPay', 'vipiosPay', 'vipBag', 'vipStar', 'vipGrow'],
				// 是否是深色状态栏
				isDarkStatus: false,
				length: ''
			}
		},
		created() {
			this.length = window.history.length
			this.judgeDarkStatus()
			this.isFromVipCenter()
			this.getToken()
			this.id = this.$route.query.id
			this.fromh5 = this.$route.query.fromh5
			this.back = this.$route.query.back
			this.isShare = this.getcommit('isShare')
		},
		mounted() {
			console.log(this.urlhandle);
		},
		methods: {
			// 完成购买
			finish(){
				console.log('------','购买完成')
				this.$router.back()
			},
			// 判断是否来自会员中心
			isFromVipCenter() {
				for (let i = 0; i < this.vipCenterList.length; i++) {
					let name = this.$route.name
					if (name.indexOf(this.vipCenterList[i]) > -1) {
						this.isVipCenter = true
					}
				}
			},
			// 判断是否需要深色状态栏
			judgeDarkStatus() {
				for (let i = 0; i < this.darkColorList.length; i++) {
					let name = this.$route.name
					if (name.indexOf(this.darkColorList[i]) > -1) {
						this.isDarkStatus = true
					}
				}
				this.changeStatusColor()
			},
			// 获取url上的信息
			getcommit(name) {
				return (
					decodeURIComponent(
						(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
							location.href
						) || ["", ""])[1].replace(/\+/g, "%20")
					) || false
				);
			},
			// 获取token
			getToken() {
				if (this.$CONFIG.isVerify && this.isIOS) {
					this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
				} else {
					this.token = this.getcommit('token') || ''
				}
				console.log(this.token);
			},
			// 修改手机状态栏的颜色
			changeStatusColor() {
				// isDarkStatus为true,调用两端方法修改状态栏为深色，否则为浅色
				if (this.isDarkStatus) {
					this.changeStatusbar('#222224', 0)
				} else {
					this.changeStatusbar('#ffffff', 1)
				}
			},
			// 两端修改状态栏的方法
			changeStatusbar(bgcolor, wordcolor) {
				var iosParam = {
					"bgcolor": bgcolor,
					"wordcolor": wordcolor
				};
				try {
					window.webkit.messageHandlers.changeStatusbar.postMessage(iosParam);
				} catch (e) {
					console.log('ios修改状态栏颜色失败', iosParam);
				}

				try {
					window.LiveAppJS.changeStatusbar(bgcolor, wordcolor);
				} catch (e) {
					console.log('安卓修改状态栏颜色失败', bgcolor, wordcolor);
				}
			},
			// 后退按钮的点击事件
			handleIconBack() {
				console.log(this.$route.name, this.urlhandle);
				if (this.urlhandle === 'back') {
					console.log('后退方式：urlhandle后退');
					this.goBack()
					return
				}
				// 如果是会员中心页，关闭容器
				if (this.$route.name === 'Home') {
					console.log('后退方式：会员中心，关闭容器');
					this.closeLayer()
				} else if (this.isVipCenter) {
					// 如果是会员支付页，h5之间跳转，地址跳转回会员中心，两端之间跳转，关闭容器
					if (!this.fromh5) {
						console.log('后退方式：两端，关闭容器');
						this.closeLayer()
					} else if (this.$route.query.isHome && this.$route.name === 'vipWelfare') {
						console.log('后退方式：app导航打开新容器进会员福利社，进优惠券详情，后退回会员福利社，后退关闭容器');
						this.closeLayer()
					} else if (this.$route.query.isHome && this.$route.name === 'vipcoupon') {
						console.log('后退方式：app导航打开新容器进会员福利社，进优惠券详情，后退回会员福利社');
						this.goBack()
					} else if (!this.$route.query.isHome && this.$route.name === 'vipcoupon') {
						console.log('后退方式：app导航打开新容器进会员福利社，进优惠券详情，后退回会员福利社');
						this.goBack()
					} else {
						console.log('后退方式：回会员中心');
						this.$router.replace({
							path: "/",
							query: {
								token: this.token,
								statistics: this.$CONFIG.statistics
							}
						})
					}
				}
				else if(this.$route.name === 'vipRefundInfo'){
					this.$router.replace({
						path: "/",
						query: {
							token: this.token,
							statistics: this.$CONFIG.statistics
						}
					})
				}
				// else if (this.$route.name === 'vipVideo' || this.$route.name === 'vipExchange') {
				//   // 会员专享视频页，地址跳转回会员中心
				//   this.$router.replace({ path: "/", query: { token: this.token, statistics: this.$CONFIG.statistics } })
				// }
				else {
					console.log('后退方式：后退');
					// 其他页面，走后退
					this.goBack()
				}
			},
			// 关闭当前层
			closeLayer() {
				var params = "close";
				try {
					window.webkit.messageHandlers.closeLayer.postMessage(params);
				} catch (e) {
					console.log("ios关闭失败");
				}
				try {
					window.LiveAppJS.closeLayer(params);
				} catch (e) {
					console.log("Android关闭失败");
				}
			},
			// 后退
			goBack() {
				this.$router.go(-1);
			},
			// 处理分享所需数据
			gotoShare() {
				if (this.$route.name === 'vipBag') {
					// 巅峰赛事包分享
					this.shareUrl = `https://${this.convertDomain('static.zhibo.tv')}/shareshop/#/dfVip?id=${this.id}`
					this.shareImg = "https://images.zhibo.tv/2021/0317/icon_df@3x.png";
					this.shareTitle = `加入${this.pageTitle}，围观精彩赛事`
					this.shareParams = {
						title: this.shareTitle,
						imageUrl: this.shareImg,
						jumpUrl: this.shareUrl
					};
				}
				if (this.$route.name === 'vipStar') {
					// 奥沙利文分享
					// url = 'https://' + this.convertDomain('static.zhibo.tv') + '/card/#/?isShare=1&token='+this.token+'&statistics='+this.$CONFIG.statistics
					this.shareUrl = `https://${this.convertDomain('static.zhibo.tv')}/h5vip/vipstar/?isShare=1&noHeader=1`
					this.shareImg = "https://images.zhibo.tv/2020/0909/cardimg.png";
					this.shareTitle = '购买奥沙利文官方授权【火星卡】，可获赠超值大礼包，先到先得哦~';
					this.shareParams = {
						title: this.shareTitle,
						imageUrl: this.shareImg,
						jumpUrl: this.shareUrl
					};
				}
				// 如果是分享页，需要调用二次分享，如果是app内的，调用两端分享
				if (this.isShare == 1) {
					console.log('调用微信二次分享');
					this.getwxShareInfo()
				} else {
					this.gotoAPPShare()
				}

			},
			// 调用两端分享
			gotoAPPShare() {
				// 两端的分享方法
				try {
					window.webkit.messageHandlers.share.postMessage(this.shareParams);
				} catch (e) {
					console.log("ios调用分享失败", this.shareParams);
				}
				try {
					window.LiveAppJS.share(this.shareTitle, this.shareImg, this.shareUrl);
				} catch (e) {
					console.log("Android调用分享失败", this.shareTitle, this.shareImg, this.shareUrl);
				}
			},
			// 处理微信二次分享
			async getwxShareInfo() {
				const params = {
					url: location.href,
					mp: 1
				}
				const res = await this.$vipapi.getWXshare(params)
				this.appid = res.data.data.appid
				this.timestamp = res.data.data.timestamp
				this.nonceStr = res.data.data.nonceStr
				this.ticket = res.data.data.ticket
				this.url = res.data.data.url
				// if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				// this.signature = decodeURIComponent(res.data.data.sign)
				// } else {
				this.signature = res.data.data.sign
				// }

				let wx = {}
				const that = this
				if (process.browser) {
					wx = require('weixin-js-sdk')

					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: this.appid, // 必填，公众号的唯一标识
						timestamp: this.timestamp, // 必填，生成签名的时间戳
						nonceStr: this.nonceStr, // 必填，生成签名的随机串
						signature: this.signature, // 必填，签名，见附录1
						ticket: this.ticket,
						jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ',
							'onMenuShareWeibo', 'onMenuShareQZone'
						] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
					})
					wx.ready(function() {
						wx.onMenuShareTimeline({ // 分享到朋友圈
							title: that.shareTitle, // 分享标题
							link: that.shareUrl, // 分享链接
							imgUrl: that.shareImg // 分享图标
						})

						// 分享给朋友
						wx.onMenuShareAppMessage({
							title: that.shareTitle,
							desc: that.shareTitle,
							link: that.shareImg, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: that.shareImg
							// success () {
							//   // 用户确认分享后执行的回调函数
							//   alert(1, that.title)
							//   alert(2, that.url)
							//   alert(3, that.imgurl)
							// },
							// cancel () {
							//   // 用户取消分享后执行的回调函数
							//   alert('分享给朋友失败')
							// }
						})
						wx.onMenuShareQQ({ // 分享到QQ
							title: that.shareTitle, // 分享标题
							desc: that.shareTitle, // 分享描述
							link: that.shareUrl, // 分享链接
							imgUrl: that.shareImg // 分享图标
							// success () {
							//   // 用户确认分享后执行的回调函数
							//   alert('分享给QQ成功')
							// },
							// cancel () {
							//   // 用户取消分享后执行的回调函数
							//   alert('分享给QQ失败')
							// }
						})
						wx.onMenuShareWeibo({ // 分享到腾讯微博
							title: that.shareTitle, // 分享标题
							desc: that.shareTitle, // 分享描述
							link: that.shareUrl, // 分享链接
							imgUrl: that.shareImg // 分享图标
							// success () {
							//   // 用户确认分享后执行的回调函数
							//   alert('分享到腾讯微博成功')
							// },
							// cancel () {
							//   // 用户取消分享后执行的回调函数
							//   alert('分享到腾讯微博失败')
							// }
						})
						wx.onMenuShareQZone({ // 分享到QQ空间
							title: that.shareTitle, // 分享标题
							desc: that.shareTitle, // 分享描述
							link: that.shareUrl, // 分享链接
							imgUrl: that.shareImg // 分享图标
							// success () {
							//   // 用户确认分享后执行的回调函数
							//   alert('分享到QQ空间成功')
							// },
							// cancel () {
							//   // 用户取消分享后执行的回调函数
							//   alert('分享到QQ空间失败')
							// }
						})
					})
				}
			},
			// 判断环境
			convertDomain(currDomain) {
				var localDomain = window.location.host
				var name = localDomain.split('.', 2)[0]
				var arr = name.split('-', 2)
				return arr.length > 1 ? arr[0] + '-' + currDomain : currDomain
			},
		},
	}
</script>
<style lang='less' scoped>
	.publicHeader {
		width: 100%;
		height: 0.88rem;
		box-sizing: border-box;
		background: #222224;
		padding: 0 0.3rem;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9;

		.container {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;

			.icon_back {
				position: absolute;
				left: 0;
				width: 0.2rem;
				height: 0.36rem;
				padding-right: 0.4rem;

				img {
					display: block;
					width: 0.2rem;
					height: 0.36rem;
				}
			}

			.pageTitle {
				flex: 1;
				text-align: center;
				font-size: 0.34rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #d8bea4;
			}

			.icon_share {
				width: 0.36rem;
				height: 0.36rem;
				position: absolute;
				right: 0;

				img {
					display: block;
					width: 0.36rem;
					height: 0.36rem;
				}
			}
			
			.text_finish{
				position: absolute;
				right: 0;
				font-size: .3rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #CAAB8E;
			}
		}
	}

	.whitebg {
		background: #fff;

		.pageTitle {
			color: #333 !important;
		}
	}
</style>
